import { configureStore } from '@reduxjs/toolkit';
import { SkillsManagementClient } from '../apiClients/SkillsManagementClient';
import DisciplineReducer from '../Reducers/DisciplineReducer';
import UnitReducer from '../Reducers/UnitReducer';
import SkillsReducer from '../Reducers/Skills';
import { postesReducer } from '../Reducers/PosteReducer';
import {employeesReducer} from  '../Reducers/EmployeesReducer'
import { evaluationsReducer } from '../Reducers/EvaluationReducer';
import { requirementsReducer } from '../Reducers/RequiremetSkillReducer';
import { rolesReducer } from '../Reducers/RolesReducer';
import { userCompanyReducer } from '../Reducers/UserCompanyReducer';
import { setupListeners } from '@reduxjs/toolkit/query'
import { raterTypesReducer } from '../Reducers/RaterTypeReducer';
import { practicalEvidencesReducer } from '../Reducers/PracticalEvidenceReducer';
import { quizzesReducer } from '../Reducers/QuizReducer';
import questionQuizReducer from '../Reducers/QuestionQuizReducer';
import optionQuizReducer from '../Reducers/OptionQuizReducer';
import quizAttemptsReducer from '../Reducers/QuizAttemptReducer';
import quizResponsesReducer from '../Reducers/QuizResponseReducer';

export const store = configureStore({
  reducer: {
    [SkillsManagementClient.reducerPath]: SkillsManagementClient.reducer,
    DisciplineReducer: DisciplineReducer,
    UnitReducer: UnitReducer,
    skills: SkillsReducer,
    postes: postesReducer,
    roles: rolesReducer,
    userCompanies: userCompanyReducer,
    employees: employeesReducer,
    evaluations: evaluationsReducer,
    requirements: requirementsReducer,
    raterTypes: raterTypesReducer,
    practicalEvidences: practicalEvidencesReducer,
    quizzes: quizzesReducer,
    quizQuestions: questionQuizReducer,
    questionOptions: optionQuizReducer,
    quizAttempts: quizAttemptsReducer,
    quizResponses: quizResponsesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(SkillsManagementClient.middleware),
  devTools: process.env.NODE_ENV !== 'production',
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)